module.exports = "<p>\r\n  paginator works!\r\n</p>\r\n"